
import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomButton from "components/button/CustomButton";
import httpClient from "services/network/httpClient";
import axios from "axios";
import { motion } from "framer-motion";
import DataTable from "components/DataTable";
import { Row } from "components/DataTable/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEye, faFilter } from "@fortawesome/free-solid-svg-icons";
import Modal from "components/Modal";
import CompleteDemo from "pages/dashboard/completeDemo/CompleteDemo";
import DemoReportFilter, { FilterFormValues } from "pages/summary/demo/DemoReportFilter";
import appConfig from "services/config";
import FilterBadge, { FilterChip } from "components/filter/FilterBadge";
import { getFileNameFromDisposition } from "pages/summary/VisitReport";
import { msToDateInput } from "../summary/DemoReport"

interface TotalDemoCountProps {
    totalCompletedDemos: number;
    totalPendingDemos: number
}

interface EmployeeTaskViewProps {
    employeeId: string;
    firstName: string;
    city: string;
    completedDemo: number;
    pending: number;
}

export interface EmployeeTaskProps {
    employeeCode: string;
    employeeName: string;
    managerName: string;
    managerCode: string;
    totalDemos: number;
    totalVisits: number;
    completedDemo: number;
    pendingDemos: number;
    completedVisits: number;
    pendingVisits: number

}

// export const getDefaultDateRange = () => {
//     const now = new Date();

//     const fromDateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01T00:00:00`;
//     const toDateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}T23:59:59`;

//     // Convert string → Date → epoch (ms)
//     const fromDateEpoch = new Date(fromDateStr).getTime();
//     const toDateEpoch = new Date(toDateStr).getTime();

//     console.log("From (epoch):", fromDateEpoch);
//     console.log("To (epoch):", toDateEpoch);

//     // return { fromDate: fromDateEpoch, toDate: toDateEpoch };
//     return {
//         fromDate: String(fromDateEpoch),
//         toDate: String(toDateEpoch)
//     };
// };

export const getDefaultDateRange = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = now.getMonth();

    // ✅ Start of month (00:00:00.000)
    const fromDate = new Date(year, month, 1, 0, 0, 0, 0);

    // ✅ End of month (23:59:59.999)
    const toDate = new Date(year, month + 1, 0, 23, 59, 59, 999);

    return {
        fromDate: String(fromDate.getTime()),
        toDate: String(toDate.getTime()),
    };
};
interface FilterData {
    fromDate?: string;
    toDate?: string;
    manager?: string;
    employee?: string;
    product?: string;
    crop?: string;
}

interface ReportActionsProps {
    row: any;
    onView: (row: any) => void;
}

const ReportActionsCell: React.FC<ReportActionsProps> = ({ row, onView }) => (
    <div className="flex space-x-2">
        <button
            onClick={() => onView(row)}
            className="p-2
        bg-blue-50 dark:bg-blue-900/40
        text-blue-600 dark:text-blue-300
        hover:bg-blue-100 dark:hover:bg-blue-900/60
        rounded-lg transition-colors"
            title="View Details"
        >
            <FontAwesomeIcon icon={faEye} />
        </button>
    </div>
);

const ReportList = () => {
    const [demoList, setDemoList] = useState<Row[]>([]);
    const [totalDemoCount, setTotalDemoCount] = useState<TotalDemoCountProps>();
    const [loading, setLoading] = useState(false);
    const [isOpenView, setIsOpenView] = useState(false);
    const [viewData, setViewData] = useState<EmployeeTaskViewProps | null>(null);
    const [isFilterOpened, setIsFilterOpened] = useState(false);
    const [activeFilterParams, setActiveFilterParams] = useState<Record<string, string>>({});
    const activeFilterParamsRef = useRef<Record<string, string>>({});
    const [isDownloading, setIsDownloading] = useState(false);
    const [activeFilterFormValues, setActiveFilterFormValues] = useState<Partial<FilterFormValues>>({});
    const [filterChips, setFilterChips] = useState<FilterChip[]>([]);

    console.log(totalDemoCount);
    console.log(loading);

    const getDemoData = async () => {
        setLoading(true);
        const { fromDate, toDate } = getDefaultDateRange();
        await httpClient.get(`/reports/report-data?fromDate=${fromDate}&toDate=${toDate}`)
            .then((response: any) => {
                console.log(response);
                if (response.success) {
                    console.log("You are inside visit list: ", response.value.employeeVisitCounts)
                    setDemoList(response.value);
                    setTotalDemoCount(response.value.totalCounts);
                }
            }).catch((error) => {
                console.error("Get data error: ", error);
            }).finally(() => {
                setLoading(false);
            });
    }
    const handleView = (row: any) => {
        setIsOpenView(true);
        setViewData({
            employeeId: String(row.userId),
            firstName: row.employeeName,
            city: row.employeeName,
            completedDemo: row.completedDemos,
            pending: row.pendingDemos,
        });
    };

    const renderActions = useCallback(
        (row: any) => <ReportActionsCell row={row} onView={handleView} />,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
    const column = [
        {
            key: "managerName",
            label: "Manager Name",
            headerClassName: "text-gray-800 dark:text-white",
            render: (_: any, row: any) => (
                <div className="flex flex-row item-center">
                    <div>
                        <div className="font-medium text-sm text-gray-800 dark:text-gray-200">{row.managerName || 'Direct'}</div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                            {(row.managerCode !== "N/A") && row.managerCode}
                        </div>
                    </div>
                </div>
                // <span>{row.managerCode && row.managerCode !== "N/A" ? `${row.managerCode}/${row.managerName}` : (row.managerName ?? "—")}</span>
            ),
        },

        {
            key: "employeeName",
            label: "Employee Name",
            headerClassName: "text-gray-800 dark:text-white",
            render: (_: any, row: any) => (
                <div className="flex flex-row item-center">
                    <div>
                        <div className="font-medium text-gray-800 dark:text-gray-200">{row.employeeName || 'Direct'}</div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                            {row.employeeCode && row.employeeCode}
                        </div>
                    </div>
                </div>
                // <span>{row.employeeCode ? `${row.employeeCode}/${row.employeeName}` : row.employeeName}</span>
            ),
        },

        {
            key: "totalDemos",
            label: "Total Demos",
            headerClassName: "text-gray-800 dark:text-white",
        },
        {
            key: "completedDemos",
            label: "Completed Demo",
            headerClassName: "text-gray-800 dark:text-white",
        },
        {
            key: "pendingDemos",
            label: "Follow Up Demo",
            headerClassName: "text-gray-800 dark:text-white",
        },
        {
            key: "totalVisits",
            label: "Total Visits",
            headerClassName: "text-gray-800 dark:text-white",
        },
        {
            key: "completedVisits",
            label: "completed Visits",
            headerClassName: "text-gray-800 dark:text-white",
        },
        {
            key: "pendingVisits",
            label: "Follow Up Visits",
            headerClassName: "text-gray-800 dark:text-white",
        },
        {
            key: "actions",
            label: "Actions",
            headerClassName: "text-gray-800 dark:text-white",
            excludeExport: true,
            actions: renderActions,
        },
    ]

    useEffect(() => {
        getDemoData();
    }, []);


    const onSubmit = (data: FilterData) => {
        // Build params — only include fields the user actually filled in
        const params: Record<string, string> = {};
        if (data.fromDate) params.fromDate = `${data.fromDate}`;
        if (data.toDate) params.toDate = `${data.toDate}`;
        if (data.manager && data.manager !== "All") params.managerId = data.manager;
        if (data.employee && data.employee !== "All") params.empIds = data.employee;
        if ((data as any).product && (data as any).product !== "All") params.productId = (data as any).product;
        if ((data as any).crop && (data as any).crop !== "All") params.cropId = (data as any).crop;
        if ((data as any).status === 0 || (data as any).status === 1 && (data as any).status !== "All") params.status = (data as any).status;
        if ((data as any).distributor && (data as any).distributor !== "All") params.distributor = (data as any).distributor;

        // Store for reuse (e.g. Download button)
        activeFilterParamsRef.current = params;
        setActiveFilterParams(params);
        // Always store as string for popup
        setActiveFilterFormValues({
            ...data,
            fromDate: msToDateInput(params.fromDate),
            toDate: msToDateInput(params.toDate),
        });
        setIsFilterOpened(false);

        // Build filter chips
        const chips: FilterChip[] = [];
        if (params.fromDate || params.toDate) {
            chips.push({
                id: "dateRange",
                label: `Date: ${msToDateInput(params.fromDate)} – ${msToDateInput(params.toDate)}`,
                onRemove: () => removeChip("dateRange", ["fromDate", "toDate"], ["fromDate", "toDate"]),
            });
        }
        if (params.managerId) {
            chips.push({
                id: "manager",
                label: `Manager: ${(data as any).__managerLabel ?? params.managerId}`,
                onRemove: () => removeChip("manager", ["managerId"], ["manager"]),
            });
        }
        if (params.empIds) {
            chips.push({
                id: "employee",
                label: `Employee: ${(data as any).__employeeLabel ?? params.empIds}`,
                onRemove: () => removeChip("employee", ["empIds"], ["employee"]),
            });
        }
        if (params.status !== undefined) {
            chips.push({
                id: "status",
                label: `Status: ${(data as any).__statusLabel ?? params.status}`,
                onRemove: () => removeChip("status", ["status"], ["status"]),
            });
        }
        setFilterChips(chips);

        httpClient.get(
            `/reports/report-data?${new URLSearchParams(params).toString()}`,
        )
            .then((response: any) => {
                console.log("This is the Demo Details Report: ", response);
                setDemoList(response.value);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleClearFilter = () => {
        activeFilterParamsRef.current = {};
        setActiveFilterParams({});
        setActiveFilterFormValues({});
        setFilterChips([]);
        getDemoData();
    };

    const removeChip = (chipId: string, paramKeys: string[], formKeys: string[]) => {
        // Read from ref — always current, even when called from a stale closure
        const newParams = { ...activeFilterParamsRef.current };
        if (chipId === "dateRange") {
            // Use default month dates instead of removing dates entirely
            const { fromDate, toDate } = getDefaultDateRange();
            newParams.fromDate = fromDate;
            newParams.toDate = toDate;
        } else {
            paramKeys.forEach(k => delete newParams[k]);
        }
        setFilterChips(prev => prev.filter(c => c.id !== chipId));
        activeFilterParamsRef.current = newParams;
        setActiveFilterParams(newParams);
        setActiveFilterFormValues(prev => {
            const next = { ...prev } as any;
            // Always store as string for popup
            next.fromDate = msToDateInput(newParams.fromDate);
            next.toDate = msToDateInput(newParams.toDate);
            formKeys.forEach(k => { if (k !== "fromDate" && k !== "toDate") delete next[k]; });
            return next;
        });
        httpClient.get(`/reports/report-data?${new URLSearchParams(newParams).toString()}`)
            .then((response: any) => { if (response.success || response.value) setDemoList(response.value); })
            .catch(console.error);
    };

    const handleDownloadExcel = async () => {
        const token = localStorage.getItem("accessToken");
        const baseUrl = appConfig.getBaseUrl();
        console.log("Base Url : ", baseUrl)
        // Use active filter params if the user applied a filter, otherwise fall back to default date range
        const params: Record<string, string> = Object.keys(activeFilterParams).length > 0
            ? { ...activeFilterParams }
            : (() => {
                const { fromDate, toDate } = getDefaultDateRange();
                return { fromDate, toDate };
            })();

        setIsDownloading(true);

        await axios.get(
            `${baseUrl}/reports/demos?${new URLSearchParams(params).toString()}`,
            {
                responseType: "blob",
                headers: { Authorization: `Bearer ${token}` },
            }
        )
            .then((response) => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })
                );
                const disposition = response.headers["content-disposition"];
                console.log("This is the vist excell response: ", response);
                console.log("THis is the Visit excell export disposition : ", disposition);
                const fileName = getFileNameFromDisposition(disposition);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Generate Report error: ", error);
            })
            .finally(() => {
                setIsDownloading(false);
            })
    };

    return (
        <div className="w-full ">
            <section className="w-full flex flex-row justify-between gap-4 mb-4">
                <section className="max-w-[75%] w-[50%] md:w-full flex flex-row items-center justify-start lg:gap-10 gap-4">
                    <h2 className="text-gray-800 dark:text-white text-xl font-semibold">Summary Report</h2>


                </section>
                <section className="flex flex-row gap-4">
                    <div className="relative">
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => setIsFilterOpened(!isFilterOpened)}
                            className="relative px-3 py-2 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-400 rounded-lg hover:bg-indigo-100 dark:hover:bg-indigo-800/40 transition-colors duration-200 flex items-center"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-1.5" />
                            <span>Filter</span>
                            {filterChips.length > 0 && (
                                <span className="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-blue-600 text-[10px] text-white font-bold">
                                    {filterChips.length}
                                </span>
                            )}
                        </motion.button>

                        {isFilterOpened && (
                            <div
                                style={{
                                    position: 'absolute',
                                    zIndex: 50,
                                    top: '100%',
                                    right: 0,
                                    marginTop: '8px',
                                    width: '400px',
                                    maxWidth: 'calc(100vw - 2rem)'
                                }}
                            >
                                <DemoReportFilter onClose={() => setIsFilterOpened(false)} title="Generate Summary Report" onSubmit={onSubmit} onReset={handleClearFilter} initialValues={activeFilterFormValues} />
                            </div>
                        )}
                    </div>
                    <CustomButton
                        onClick={handleDownloadExcel}
                        loading={isDownloading}
                    >
                        {
                            !isDownloading && <FontAwesomeIcon icon={faDownload} className="mr-1.5" />
                        }
                        Download
                    </CustomButton>
                </section>
            </section>

            <FilterBadge count={filterChips.length} onClear={handleClearFilter} chips={filterChips} />

            <section className=" h-full">
                <DataTable
                    columns={column}
                    data={demoList}
                    isExport={false}
                    isSearchBtn={false}
                    isAddBtnTrue={false}
                    loading={loading}
                />
            </section>


            {isOpenView && (
                <Modal
                    isOpen={isOpenView}
                    onClose={() => setIsOpenView(false)}
                    header="Demo Details"
                    size="full"
                    customHeight="90vh"
                >
                    <CompleteDemo viewData={viewData} />
                </Modal>
            )}
        </div>
    )

}
export default ReportList